import Board from "../models/board";
import { apiResultSuccess, getHabitDetails } from "../apihelper";
import Habit from "../models/habit";

export default class HabitsController extends Board {

    constructor(
        id=-1, 
        title='', 
        type='', 
        orderIndex=-1,
        dateCreated='', 
        lastUpdated='', 
        hidden=false
    ) {
        super(parseInt(id), title, type, orderIndex, dateCreated, lastUpdated, hidden);

        this.habits = [];
    }

    getHabits() {
        return this.habits;
    }

    setHabits(newHabits=[]) {
        this.habits = newHabits;
    }

    // API helper
    // Checks for success result
    // Upon success calls createHabits
    // Runs reload on subject
    handleAPIResult(results) {
        if ( apiResultSuccess(results) ) {
            if ( results.habits ) {
                this.createHabits(results.habits);
                this.subject.runReload();
            }
        }
    }

   async fetchData() {
        return this.fetchHabits();
    }

    // Fetch habits data from API
    // When done call handleAPIResult fn
    fetchHabits() {
        getHabitDetails(
            (results) => {
                this.handleAPIResult(results);
            }, this.id
        )
    }

    // Refetch habits
    async reloadData() {
        return this.fetchData();
    }

    // Iterates through newHabits
    // Creates a Habit for each
    // appends it to a new array
    // Updates habits with new array
    createHabits(newHabits=[]) {
        const habits = [];

        newHabits.forEach(data => {
            const habit = new Habit(data);
            habits.push(habit);
        });

        this.setHabits(habits);
    }

    // Creates a new Habit from newData
    // Adds it to habits array
    // Notifies subject to reload
    addNew(newData) {
        const newHabit = new Habit(newData);
        newHabit.animate = true;
        this.habits.unshift(newHabit);

        this.subject.runReload();
    }

    // Filters habits array by id
    // Assigns to habits
    // Notifies subject to reload
    delete(id=-1) {
        if ( id !== -1 ) {
            const newHabits = this.habits.filter(habit => habit.id !== id);
            this.setHabits(newHabits);
            this.subject.runReload();
        }
    }
}